import React, { useEffect, useState } from "react";
import { ReactComponent, Utils } from "@formio/react";
import qrCodeSettingsForm from "./QRCode.SettingsForm"; // Import settings form for QR Code
import QRCode from "qrcode"; // Import QRCode component
import ReactDOM from "react-dom/client"; // Import ReactDOM

const QRCodeCustomComp = ({ ...props }) => {
	const [imgUrl, setImgUrl] = useState("");

	useEffect(() => {
		if (props.data) {
			Object.keys(props.data).forEach((key) => {
				props.form._data[key] = props.data[key];
			});
			if (props.insideGrid) {
				delete props.form._data[props.component.key];
			}
		}
	}, [props.data]);

	useEffect(() => {
		const { component, form } = props;

		if (!component || !form) return;

		const { requestUrl, responseDataPath = "", dataID, key, toggleVisibility = true } = component;

		// Construct the base domain URL
		const fullDomain = requestUrl?.trim() || `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;

		// Retrieve the dynamic ID from form data
		const id = form._data?.[dataID];
		if (!id) return;

		// Construct the final data for the QR code
		const rawData = `${fullDomain}/${responseDataPath}${id}`;
		if (!rawData) return;

		// Generate QR code and update form data
		QRCode.toDataURL(rawData)
			.then((base64) => {
				setImgUrl(base64);
				form._data[key] = {
					value: rawData,
					image: base64,
				};
			})
			.catch((err) => console.error("QR code generation failed:", err));
	}, [props?.component?.key]);

	const isVisible = props?.component?.toggleVisibility !== false;

	return (
		<>
			{imgUrl && (
				<div style={{ display: isVisible ? "block" : "none" }}>
					<img src={props.form._data[props.component.key].image} alt="QR Code" />
				</div>
			)}
		</>
	);
};

export default class QRCodeComponent extends ReactComponent {
	static shouldSetValue = false;

	constructor(component, options, data) {
		options["oldState"] = {};
		super(component, options, data);
		this.reactInstance = null;
	}

	static schema(...extend) {
		return ReactComponent.schema({
			type: "qrcodeCustomComp",
			label: "QR Code",
			dataKey: "qrCodeData",
		});
	}

	static get builderInfo() {
		return {
			title: "QR Code",
			icon: "qrcode",
			group: "Basic",
			documentation: "",
			weight: -10,
			schema: QRCodeComponent.schema(),
		};
	}

	static editForm = qrCodeSettingsForm; // Use settings form for QR Code

	attachReact(element, ref) {
		let insideGrid = false;

		const root = ReactDOM.createRoot(element); // Use ReactDOM.createRoot
		let key = this.component.key;

		const rootForm = this.getRoot();

		Utils.eachComponent(
			rootForm.components,
			function (component) {
				if (component.component.type === "editgrid") {
					Utils.eachComponent(
						component.component.components,
						function (component2) {
							if (!insideGrid) {
								insideGrid = component2.key === key;
							}
						},
						true
					);
				}
			},
			true
		);

		root.render(
			<QRCodeCustomComp
				component={this.component}
				onChange={this.updateValue}
				value={this.dataValue}
				data={this.data}
				form={rootForm}
				oldState={this.options["oldState"]}
				insideGrid={insideGrid}
			/>
		);
	}

	detachReact(element) {
		return;
	}

	setValue(value) {
		if (this.reactInstance) {
			this.reactInstance.setState({
				value: value,
			});
			this.shouldSetValue = false;
		} else {
			this.shouldSetValue = true;
			this.dataForSetting = value;
		}
	}

	checkValidity(data, dirty, rowData) {
		const valid = super.checkValidity(data, dirty, rowData);
		if (!valid) {
			return false;
		}
		return this.validate(data, dirty, rowData);
	}

	validate(data, dirty, rowData) {
		return true;
	}
}
